import { Radio } from 'antd';
import styled from 'styled-components';

export const RadioButtonStyled = styled(Radio.Button)`
  padding: 1.8em 0;
  background-color: white;
  border: solid 0.5px #ececec;
  align-items: center;
  flex-direction: row;
  color: #111;
  min-width: 100%;
  margin: 1% 0;
  :hover {
    color: black;
  }
  :focus-within {
    box-shadow: none;
  }
  & img {
    margin-right: 10px;
  }
  &.ant-radio-button-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    font-w: 17px;
    font-weight: 600;
  }
  &.ant-radio-button-wrapper:first-child:last-child {
    border-radius: 10px;
    color: black;
  }
  &.ant-radio-button-wrapper:last-child::before {
    display: none;
  }
  &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    border: solid 2.8px #198754;

    :focus-within {
      box-shadow: none;
    }
    :before {
      border: #198754;
      background-color: unset;
    }
    &.ant-radio-button-wrapper-checked:not([class*=" ant-radio-button-wrapper-disabled"]).ant-radio-button-wrapper:first-child {
      border-right-color: #198754;
    }
    &.ant-radio-button-wrapper-checked:not([class*=" ant-radio-button-wrapper-disabled"]).ant-radio-button-wrapper:first-child {
      border-right-color: #198754;
    }
  }
`;

export const RadioGroupStyled = styled(Radio.Group)`
  text-align: center;
  color: black;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 4% 0;
  flex-wrap: wrap;
  width: 100%;
`;
